module.exports = __webpack_public_path__ + "static/media/Enghouse_lifesize_white.c9bb9ea4.svg";